import { clsx } from 'clsx';

interface BadgeProps {
  size: 'extra-small' | 'small' | 'medium';
  accented?: boolean;
  num?: number;
  behavior: 'first' | 'second';
  className?: string;
  testId?: string;
}

const baseClasses = clsx(
  'text-small relative shrink-0 rounded-m border border-white',
);

const sizeClasses = {
  'extra-small': clsx('h-xs w-xs'),
  small: clsx('h-s w-s'),
  medium: clsx('h-m w-m'),
};

const accentedClasses = clsx('bg-brand');

const Badge = ({
  size,
  accented,
  num,
  behavior,
  className,
  testId,
}: BadgeProps) => {
  const handleBadgeNumber = () => {
    if (num === undefined) {
      return num;
    }

    if (behavior === 'first') {
      return num;
    }

    return num > 9 ? '9+' : num;
  };

  return (
    <div
      className={clsx(
        baseClasses,
        sizeClasses[size],
        accented ? accentedClasses : 'bg-contrast',
        behavior === 'first' && num && num > 9 && '!h-m !w-m',
        className,
      )}
      data-testid={testId}
    >
      {num && size !== 'extra-small' && (
        <div className="-translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2 text-center text-inverted text-small">
          {handleBadgeNumber()}
        </div>
      )}
    </div>
  );
};

export default Badge;
